import { Component, OnInit, Input, ViewContainerRef, HostListener } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Onboarding, Status, OnboardingType, LeadSource } from '../../../models/onboarding';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {AlgPrivacyModalComponent} from '../../dialogs/alg-privacy-modal/alg-privacy-modal.component';
import { ModalDialogService } from 'ngx-modal-dialog';
import { UtilsService } from '../../../services/utils.service';
import { Privacy } from '../../../models/privacy';
import { AlgPrivacyService } from '../../../services/alg-privacy.service';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';


@Component({
  selector: 'alg-call-me',
  templateUrl: './alg-call-me.component.html',
  styleUrls: ['./alg-call-me.component.scss']
})

export class AlgCallMeComponent implements OnInit {
  public step: any;
  public currentOnboarding: Onboarding;
  public informativeNoteUrl$: Observable<string>;
  public phoneNumber: number;
  public callmeSucces: boolean;
  public recallForm: FormGroup;
  public phone_call: string;
  public callable: boolean = false;
  public callme_privacy: string;
  public labelMessage: any
  public screenWidth: any;
  public isTablet: boolean;

  constructor(
    private api: ApiService, 
    private utils: UtilsService, 
    private modalDialogService: ModalDialogService, 
    private viewContainer: ViewContainerRef,
    private privacySerice: AlgPrivacyService) {
      this.informativeNoteUrl$ = this.privacySerice.onbPrivacyUrl$
      .pipe(
        map((urls) => urls.informativeNote)
      );
     }

     @HostListener('window:resize', ['$event'])
      onResize(event) {
        this.labelMessage = (window.innerWidth >= 768) ? 'Li trovi dettagliati nella schermata a fianco' : 'Li trovi in alto, sotto la voce ‘documenti necessari’';
        this.screenWidth = window.innerWidth;
        if(this.screenWidth > 767 && this.screenWidth < 993){
          this.isTablet = true;
        } else {
          this.isTablet = false;
        }
      }

  ngOnInit() {
    this.labelMessage = (window.innerWidth >= 768) ? 'Li trovi dettagliati nella schermata a fianco' : 'Li trovi in alto, sotto la voce ‘documenti necessari’';
    this.api.currentOnboarding.subscribe(currentOnBoarding => {      
      if(currentOnBoarding.webStatus == 'contract_info') this.callable = true;
      this.step = currentOnBoarding.webStatus;
      this.currentOnboarding = currentOnBoarding;
      this.phoneNumber = this.currentOnboarding.phone;
      this.callable = true;
    });
    this.recallForm = new FormGroup({
      phone_call: new FormControl(this.phone_call, {
        validators: [Validators.required, Validators.minLength(4), Validators.maxLength(11)]
      })
    });
    // callme privacy text
    let callmeprivacy;
    callmeprivacy = Privacy('accendi');
    this.informativeNoteUrl$.subscribe(e => {
      callmeprivacy.description = callmeprivacy.description.replace('%%LINK%%', e);
      callmeprivacy.description = callmeprivacy.description.replace('<a ', '<a class="privacy-link" ');
      this.callme_privacy = callmeprivacy.description;
    });
    this.screenWidth = window.innerWidth;
    if(this.screenWidth > 767 && this.screenWidth < 992){
      this.isTablet = true;
    } else {
      this.isTablet = false;
    }
  }

  saveNumber() {    
    if(this.recallForm.status === 'VALID'){
      const callMeOnboarding = {...this.currentOnboarding};
      callMeOnboarding.phone = this.phoneNumber;
      callMeOnboarding.webStatus = Status.callme;
      callMeOnboarding.typeId = OnboardingType.callme;
      callMeOnboarding.leadSource = LeadSource.prospect;
      callMeOnboarding.firstname =  callMeOnboarding.firstname ? callMeOnboarding.firstname : 'N/D';
      callMeOnboarding.lastname =  callMeOnboarding.lastname ? callMeOnboarding.lastname : 'N/D';
      this.api.createOnboarding(callMeOnboarding).subscribe((onb: Onboarding) =>{        
        if (onb._id) {
          this.callmeSucces = true;
        }
      });
    } else {
      this.recallForm.get('phone_call').markAsTouched();
      return;
    }
  }

  public onChangeNumber(event) {    
    this.phoneNumber = event.target.value;
  }

  openModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgPrivacyModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline'
      },
      data: {
        description: modalContent.description
      }
    });
  }

  public readPrivacy(type) {
    let modalContent;
    modalContent = Privacy('accendi');
    this.informativeNoteUrl$.subscribe(e => {
      modalContent.description = modalContent.description.replace('%%LINK%%', e);
    });
    this.openModal(modalContent || {});
  }
}




// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-call-me/alg-call-me.component.ts